
import React, { useState, useEffect } from "react";
import { apiFetch, C } from "./utils/api";
import Login from "./components/Login";
import Nav from "./components/Nav";
import Bottom from "./components/Bottom";
import Mapa from "./components/Mapa";
import NapDiagram from "./components/NapDiagram";
import MufaDiagram from "./components/MufaDiagram";
import OltDiagram from "./components/OltDiagram";
import Equipos from "./components/Equipos";
import Clientes from "./components/Clientes";
import Averias from "./components/Averias";
import FormModal from "./components/FormModal";
import Settings from "./components/Settings";
import Proyectos from "./components/Proyectos";

export default function App() {
  const [user, setUser] = useState(null);
  const [proyecto, setProyecto] = useState(null);
  const [proyectos, setProyectos] = useState([]);
  const [showProyectos, setShowProyectos] = useState(false);
  const [cfg, setCfg] = useState({nombre_empresa:"Time Telco", logo:"", google_maps_key:""});
  const [view, setView] = useState("mapa");
  const [mapCenter, setMapCenter] = useState({lat:3.8397, lng:-76.5220});
  const [mapZoom, setMapZoom] = useState(14);
  const [equipos, setEquipos] = useState({olts:[], mufas:[], naps:[], fibras:[]});
  const [clientes, setClientes] = useState([]);
  const [averias, setAverias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [menu, setMenu] = useState(false);
  const [settings, setSettings] = useState(false);
  const [sel, setSel] = useState(null);
  const [addMode, setAddMode] = useState(null);
  const [form, setForm] = useState(null);
  const [fibraSelId, setFibraSelId] = useState(null);
  const [napDiagram, setNapDiagram] = useState(null);
  const [mufaDiagram, setMufaDiagram] = useState(null);
  const [oltDiagram, setOltDiagram] = useState(null);

  useEffect(()=>{ loadCfg(); },[]);
  useEffect(()=>{ if(user){ loadEq(); loadAv(); loadProyectos(); } },[user]);

  const loadCfg = async()=>{ const d=await apiFetch("/configuracion.php"); if(d.success) setCfg(d.config); };
  const loadProyectos = async()=>{ const d=await apiFetch("/proyectos.php"); if(d.success) setProyectos(d.proyectos); };
  const loadEq = async()=>{ const pid=proyecto?proyecto.id:"all"; const d=await apiFetch("/equipos.php?proyecto_id="+pid); if(d.success) setEquipos(d.data); };
  const loadAv = async()=>{ const d=await apiFetch("/averias.php?estado=abierta"); if(d.success) setAverias(d.averias); };
  const loadCl = async(nap_id)=>{ const d=await apiFetch("/clientes.php?nap_id="+nap_id); if(d.success) setClientes(d.clientes); };

  const login = async(u,p)=>{
    setLoading(true);
    const d=await apiFetch("/login.php",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({username:u,password:p})});
    setLoading(false);
    if(d.success){setUser(d.usuario);const pd=await apiFetch('/proyectos.php');if(pd.success)setProyectos(pd.proyectos);setShowProyectos(true);return null;}
    return d.error||"Credenciales incorrectas";
  };
  const logout = ()=>{ setUser(null); setEquipos({olts:[],mufas:[],naps:[],fibras:[]}); setView("mapa"); setSel(null); setProyecto(null); setShowProyectos(false); };

  const saveEq = async(tipo,data)=>{
    const r=await apiFetch("/equipos.php?tipo="+tipo,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(data)});
    if(r.success){loadEq();setForm(null);setAddMode(null);}
    return r;
  };
  const updateEq = async(tipo,data)=>{
    const r=await apiFetch("/equipos.php?tipo="+tipo,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(data)});
    if(r.success){loadEq();setForm(null);setFibraSelId(null);}
    return r;
  };
  const delEq = async(tipo,id)=>{
    if(!window.confirm("Eliminar?")) return;
    await apiFetch("/equipos.php?tipo="+tipo,{method:"DELETE",headers:{"Content-Type":"application/json"},body:JSON.stringify({id})});
    loadEq(); setSel(null);
  };
  const saveCl = async(data)=>{
    const r=await apiFetch("/clientes.php",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(data)});
    if(r.success){if(data.nap_id)loadCl(data.nap_id);setForm(null);}
    return r;
  };
  const updateCl = async(data)=>{
    const r=await apiFetch("/clientes.php",{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(data)});
    if(r.success){setForm(null);}
    return r;
  };
  const delCl = async(id)=>{
    if(!window.confirm("Eliminar cliente?")) return;
    await apiFetch("/clientes.php",{method:"DELETE",headers:{"Content-Type":"application/json"},body:JSON.stringify({id})});
    setForm(null);
  };
  const saveAv = async(data)=>{
    const r=await apiFetch("/averias.php",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(data)});
    if(r.success){loadAv();loadEq();setForm(null);}
    return r;
  };
  const updateAv = async(id,estado)=>{
    await apiFetch("/averias.php",{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({id,estado})});
    loadAv(); loadEq();
  };

  if(!user) return <Login login={login} loading={loading} cfg={cfg}/>;
  if(showProyectos) return <Proyectos proyectos={proyectos} onSelect={async(p)=>{ setProyecto(p); setShowProyectos(false); if(p){setMapCenter({lat:parseFloat(p.lat),lng:parseFloat(p.lng)});setMapZoom(parseInt(p.zoom)||14);} const pid=p?p.id:'all'; const d=await apiFetch('/equipos.php?proyecto_id='+pid); if(d.success) setEquipos(d.data); }} user={user} loadProyectos={loadProyectos}/>;

  return (
    <div style={{height:"100vh",display:"flex",flexDirection:"column",fontFamily:"Roboto,sans-serif",background:C.light}}>
      <Nav user={user} logout={logout} cfg={cfg} menu={menu} setMenu={setMenu} setSettings={setSettings}
        view={view} setView={setView} averias={averias} addMode={addMode} setAddMode={setAddMode} proyecto={proyecto} setShowProyectos={setShowProyectos}/>
      <div style={{flex:1,overflow:"hidden",position:"relative"}}>
        {view==="mapa" && cfg.google_maps_key && (
          <Mapa equipos={equipos} cfg={cfg} addMode={addMode} setAddMode={setAddMode} setForm={setForm}
            sel={sel} setSel={setSel} mapCenter={mapCenter} setMapCenter={setMapCenter}
            mapZoom={mapZoom} setMapZoom={setMapZoom} user={user} loadCl={loadCl}
            clientes={clientes} delEq={delEq} fibraSelId={fibraSelId} setFibraSelId={setFibraSelId}
            onVerDiagrama={nap=>setNapDiagram(nap)}
            onVerDiagramaMufa={mufa=>setMufaDiagram(mufa)}
            onVerDiagramaOlt={olt=>setOltDiagram(olt)}
            onLoadEq={loadEq}/>
        )}
        {napDiagram && <NapDiagram nap={napDiagram} user={user} onClose={()=>setNapDiagram(null)}/>}
        {mufaDiagram && <MufaDiagram mufa={mufaDiagram} user={user} onClose={()=>setMufaDiagram(null)}/>}
        {oltDiagram && <OltDiagram olt={oltDiagram} user={user} onClose={()=>setOltDiagram(null)}/>}
        {view==="mapa" && !cfg.google_maps_key && (
          <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100%",flexDirection:"column",gap:12}}>
            <p style={{fontSize:16,color:C.muted}}>Configura tu API Key de Google Maps</p>
            <button onClick={()=>setSettings(true)} style={{padding:"10px 20px",background:C.accent,color:C.white,border:"none",borderRadius:8,cursor:"pointer"}}>Abrir configuracion</button>
          </div>
        )}
        {view==="equipos" && <Equipos equipos={equipos} user={user} delEq={delEq} setMapCenter={setMapCenter} setMapZoom={setMapZoom} setView={setView} setForm={setForm}/>}
        {view==="clientes" && <Clientes user={user} setForm={setForm} delCl={delCl}/>}
        {view==="averias" && <Averias averias={averias} updateAv={updateAv} user={user} loadAv={loadAv}/>}
      </div>
      <Bottom view={view} setView={setView} averias={averias}/>
      {form && <FormModal form={form} setForm={setForm} equipos={equipos} saveEq={saveEq} updateEq={updateEq} saveCl={saveCl} updateCl={updateCl} saveAv={saveAv} proyecto={proyecto}/>}
      {settings && <Settings cfg={cfg} onClose={()=>setSettings(false)} loadCfg={loadCfg}/>}
    </div>
  );
}
